import * as React from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import './styles.scss'
import Profile from '../../components/profile'
import renderHTML from 'react-render-html'
import { Rail } from 'components/rail'
import { Protagonist } from 'components/protagonist'

const images = {
  bixman_1: require('../main/imgs/bixman_1.png?sizes=216w+432w+600w'),
  castle_2: require('../main/imgs/castle_2.png?sizes=216w+432w+600w'),
  dickinson_1: require('../main/imgs/dickinson_1.png?sizes=216w+432w+600w'),
  dickinson_2: require('../main/imgs/dickinson_2.png?sizes=216w+432w+600w')
}

type Props = {
  qId: number,
  continueTitle: string,
  textOneTitle: string,
  textOne: string,
  textTwoTitle: string,
  textTwo: string,
  textThreeTitle: string,
  textThree: string,
  source: string,
  articleId: number,
  solution: string,
  question: string,
  expertentext: string,
  descriptionDocument: string,
  realCaseTitle: string,
  realCaseText: string,
  titleDocument: string,
  filenameDocument: string,
  documentIsWide: boolean
}

export default class Quiz extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      quizPlayed: false,
      answerGiven: 'undefined',
      userIsCorrect: false,
      totalAnswers: -1,
      answerPerc: -1,
      answerPercTxt: 'undefined'
    }

    // Init Firebase
    let config = {
      apiKey: 'AIzaSyDK2K4LgTvb2KcTE6bUMDElqGxYKCLlo-c',
      authDomain: 'geldwaescherei-quiz-2019.firebaseapp.com',
      databaseURL: 'https://geldwaescherei-quiz-2019.firebaseio.com',
      storageBucket: 'geldwaescherei-quiz-2019.appspot.com'
    }
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    }

    this.addVote = this.addVote.bind(this)
  }

  componentWillMount() {
    let storedAnswer = window.localStorage.getItem(this.props.articleId + '-' + this.props.qId)
    console.log('STORED: ', storedAnswer)
    if (storedAnswer !== null) {
      this.setState({
        answerGiven: storedAnswer,
        userIsCorrect: storedAnswer === this.props.solution
      })
      this.getVotes(storedAnswer)
    }
  }

  /* increment in firebase */
  addVote(e) {
    let answer = e.currentTarget.getAttribute('data-answer')
    console.log('answer: ', answer)

    this.setState({ answerGiven: answer }, function() {
      console.log('SOLUTION: ', this.props.solution)
      console.log('answerGiven: ', this.state.answerGiven)
      if (this.props.solution === this.state.answerGiven) {
        this.setState({ userIsCorrect: true })
      } else {
        this.setState({ userIsCorrect: false })
      }
    })

    console.log('addVote: ', answer)
    window.localStorage.setItem(this.props.articleId + '-' + this.props.qId, answer)
    let newVote = firebase
      .database()
      .ref(
        'stories/' +
          this.props.articleId +
          '/votes/' +
          this.props.qId +
          '/' +
          answer +
          '/votes/'
      )
    newVote.transaction(
      currentVotes => {
        return currentVotes + 1
      },
      (error, committed, snapshot) => {
        if (error) {
          console.log('Transaction failed abnormally!', error)
        } else if (!committed) {
          console.log('Transaction aborted')
        } else {
          /* transaction complete */
          console.log('Transaction complete')
          this.getVotes(answer)
          // this.logClientIP(fbID, snapshot.val())

          /* update frontend */
          // this.getAllVotes()
        }
      }
    )

    let currentQuestion = e.currentTarget.getAttribute('data-question')
    console.log('currentQuestion: ', currentQuestion)

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Quiz: ' + currentQuestion
    })
  }

  getVotes(answer) {
    /* firebase request */
    firebase
      .database()
      .ref('stories/' + this.props.articleId + '/votes/' + this.props.qId)
      .once('value')
      .then(snapshot => {
        let jaVotes = snapshot.child('ja/votes').val()
        let neinVotes = snapshot.child('nein/votes').val()

        if (jaVotes === null) {
          jaVotes = 0
        }
        if (neinVotes === null) {
          neinVotes = 0
        }
        /* get quiz state from local storage */
        // extendedRow[8] = localStorage.getItem('vote-' + fbID)
        if (answer === 'ja') {
          this.setState({ totalAnswers: Number(jaVotes + neinVotes) })
          this.setState(
            {
              answerPerc: Number(
                ((jaVotes / (jaVotes + neinVotes)) * 100).toFixed(1)
              )
            },
            () =>
              this.setState({
                answerPercTxt: this.state.answerPerc
                  .toString()
                  .replace('.', ',')
              })
          )
        } else if (answer === 'nein') {
          this.setState({ totalAnswers: Number(jaVotes + neinVotes) })
          this.setState(
            {
              answerPerc: Number(
                ((neinVotes / (jaVotes + neinVotes)) * 100).toFixed(1)
              )
            },
            () =>
              this.setState({
                answerPercTxt: this.state.answerPerc
                  .toString()
                  .replace('.', ',')
              })
          )
        } else {
          this.setState({ totalAnswers: -1 })
          this.setState({ answerPerc: -1 }, () =>
            this.setState({ answerPercTxt: 'undefined' })
          )
        }
        console.log(
          '##### ' +
            answer +
            ' votes: ' +
            this.state.answerPerc +
            '% of ' +
            this.state.totalAnswers
        )
      })
  }

  render() {
    let feedBackText = 'not set'
    feedBackText = this.state.userIsCorrect
      ? "<div className='partOne'><i class='check icon green'></i>" +
        'L’expert vous donne' +
        '<b> raison. </b></div>'
      : "<div className='partOne'><i class='times icon red'></i>" +
        'L’expert dit que' +
        '<b> vous avez eu tort. </b></div>'
    if (this.state.answerPerc >= 0 && this.state.userIsCorrect) {
      feedBackText += "<div className='partTwo'>"
      feedBackText += "<span className='percentage'>"
      feedBackText += this.state.answerPerc
      feedBackText += '%</span> des '
      feedBackText += this.state.totalAnswers
      feedBackText +=
        ' participantes et participants ont choisi la même réponse que vous.'
      feedBackText += '</div>'
    } else if (this.state.answerPerc >= 0 && !this.state.userIsCorrect) {
      feedBackText += "<div className='partTwo'>"
      feedBackText += "<span className='percentage'>"
      feedBackText += this.state.answerPerc
      feedBackText += '%</span> des '
      feedBackText += this.state.totalAnswers
      feedBackText +=
        ' participantes et participants ont choisi la même réponse que vous.'
      feedBackText += '</div>'
    }
    return (
      <div>
        {images[this.props.imageTitle] && (
          <Rail className={'protagonists'} right>
            <Protagonist
              images={images[this.props.imageTitle]}
              name={this.props.titleDocument}
              filename={this.props.filenameDocument}
              isWide={this.props.documentIsWide}
              description={this.props.descriptionDocument}
            />
          </Rail>
        )}

        <div>
          <h5 className='textOneTitle'>{this.props.textOneTitle}</h5>
          <p className='textOne'>{this.props.textOne}</p>
          <h5 className='textTwoTitle'>{this.props.textTwoTitle}</h5>
          <p className='textTwo'>{this.props.textTwo}</p>
          <h5 className='textThreeTitle'>{this.props.textThreeTitle}</h5>
          <p className='textTwo'>{this.props.textThree}</p>
        </div>

        {this.state.answerGiven !== 'undefined' ? (
          <div>
            <div
              className={
                this.state.userIsCorrect
                  ? 'feedback correct'
                  : 'feedback incorrect'
              }
              style={{ marginTop: '1em' }}
            >
              <div>{renderHTML(feedBackText)}</div>
            </div>

            <Profile
              avatarSrc={require('./imgs/daniel_thelesklaf.jpg')}
              name='Daniel Thelesklaf'
              byline='Expert en lutte contre le blanchiment d’argent '
            >
              {this.props.expertentext}
            </Profile>

            <div className='realCase'>
              <h5 className='realCaseTitle'>{this.props.realCaseTitle}</h5>
              <p className='realCaseText'>{this.props.realCaseText}</p>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: '1em' }}>
            <h5 className='question-title'>{this.props.question}</h5>

            <div className='buttonWrapper two ui buttons'>
              <button
                class='ui button quiz left'
                data-answer='ja'
                data-question={this.props.qId}
                onClick={this.addVote}
              >
                <i class='check icon' />
                Oui
              </button>

              <button
                class='ui button quiz right'
                data-answer='nein'
                data-question={this.props.qId}
                onClick={this.addVote}
              >
                <i class='times icon' />
                Non
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }
}
